<template>
  <div>
    <section class="page-banner"><img :src="image" :alt="title"><div><p class="eyebrow">{{ eyebrow }}</p><h1>{{ title }}</h1><p>{{ subtitle }}</p></div></section>
    <div class="breadcrumb"><router-link to="/">{{ $t('common.home') }}</router-link><span>/</span>{{ title }}</div>
  </div>
</template>
<script>
import { getBanners, resolveAssetUrl } from '../api/public'
export default {
  name: 'PageHero',
  props: { position: { type: String, required: true }, fallback: { type: Object, required: true } },
  data() { return { banner: null } },
  computed: { title() { return this.banner?.title || this.fallback.title }, subtitle() { return this.banner?.subtitle || this.fallback.subtitle }, eyebrow() { return this.fallback.eyebrow }, image() { return resolveAssetUrl(this.banner?.imageUrl, this.fallback.image) } },
  watch: { '$i18n.locale': 'loadBanner' },
  mounted() { this.loadBanner() },
  methods: { async loadBanner() { try { const data = await getBanners(this.position); this.banner = data?.length ? data[0] : null } catch (error) { this.banner = null } } }
}
</script>
